import { createAppRoute } from '@/router/common.js'
import { useAssetsStore } from '@/stores/l3anaheim/assets'
import { useJobStore } from '@/stores/l3anaheim/job.js'
import { useRemoteCommandConfigsStore } from '@/stores/common/remote-command-configs'

export default [
  createAppRoute(
    () => import('@/views/l3anaheim/job-listing-page.vue'),
    '/jobs',
    {
      requiresAuth: true,
      storeFn: useJobStore,
    },
    'JobListingPage'
  ),
  createAppRoute(
    () => import('@/views/l3anaheim/job-mono.vue'),
    '/jobs/mono',
    {
      requiresAuth: true,
      storeFn: useJobStore,
    },
    'JobForm'
  ),
  createAppRoute(
    () => import('@/views/l3anaheim/asset-listing-page.vue'),
    '/assets',
    {
      requiresAuth: true,
      storeFn: useAssetsStore,
    },
    'AssetListingPage'
  ),
  createAppRoute(
    () => import('@/views/l3anaheim/asset-mono.vue'),
    '/assets/mono',
    {
      requiresAuth: true,
      storeFn: useAssetsStore,
    },
    'AssetForm'
  ),
  createAppRoute(() => import('@/views/common/remote-command-configs/mono.vue'), '/remote-command-configs/mono', {
    requiresAuth: true,
    storeFn: useRemoteCommandConfigsStore,
  }),
  createAppRoute(
    () => import('@/views/common/remote-command-configs/index.vue'),
    '/remote-command-configs',
    { requiresAuth: true, storeFn: useRemoteCommandConfigsStore },
    'remoteCommandConfigsListingPage'
  ),
]
